export function RadioButton<T extends string | number>({
  id,
  name,
  value,
  checked,
  onChange,
  label,
  disabled = false,
  className = '',
}: {
  id: string;
  name: string;
  value: T;
  checked: boolean;
  onChange: (value: T) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <div className={`flex items-center ${className}`}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value.toString()}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
        className={`w-4 h-4 transition-all duration-200 focus:ring-0 ${
          checked ? 'text-primary border-primary' : 'text-neutral-600 border-neutral-600 hover:border-primary/50'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        style={{
          accentColor: 'rgb(var(--oui-color-primary))', // Primary green color from CSS variable
          colorScheme: 'dark',
        }}
      />
      {label && (
        <label
          htmlFor={id}
          className={`ml-2 text-sm font-medium ${
            disabled ? 'text-neutral-500 cursor-not-allowed' : 'text-neutral-300 cursor-pointer'
          }`}
        >
          {label}
        </label>
      )}
    </div>
  );
}
